import FilterRegistry from './FilterRegistry';

/**
 * A decorator used to register filters with the page framework.
 *
 * @param {Object} options The decorator options.
 * @param {String} options.filterId The filter's ID.
 * @param {Function} options.filterStateServiceFactory The factory function that provides the filter's state service.
 */
export default function Filter(options) {
    return (filterType) => {
        const filterIdRegExp = new RegExp(`\\b${options.filterId}\\b`);
        FilterRegistry.registerFilter(options.filterId, filterIdRegExp, filterType);
        FilterRegistry.registerFilterStateServiceFactory(filterIdRegExp, options.filterStateServiceFactory);
        return filterType;
    };
}
